export default {"src":"/_next/static/media/dashboard-avator-dropdown-arrow.63d82a9c.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};